import React, { useContext, useState } from 'react';
import AppContext from "../../AppContext";
import KidRow from "./KidRow";
import { FormService, Lang, ModalService, Api } from "./../../services/Services";
import { BaseSubmit, InputDiv, RegiBtns } from "./../utils/Utils";
import { newKidRow } from "../Funcs";

const langText = (area, term, fallback) => {
	if (Lang[area] && Lang[area][term]) {
		return Lang[area][term];
	}
	return fallback;
};

const ForgotUsername = ({ closeForgot, onOpenInitSecondHand }) => {
	const context = useContext(AppContext);
	const fieldsObj = {};
	fieldsObj.activationCode = useState((context.UserService.activationCode || "").toUpperCase());
	fieldsObj.phone = useState("");
	fieldsObj.newEmail = useState("");
	const [kid, kidUpd] = useState(newKidRow());
	const [errors, errorsUpd] = useState({});
	const [servError, servErrorUpd] = useState(null);
	const [submitDisabled, submitDisabledUpd] = useState(false);

	const fields = [
		{ name: "activationCode", validation: { notEmpty: true, activationCode: true }, toUpperCase: true, placeholder: langText("forgot_username", "label_activation_code", "Activation code") },
		{ name: "phone", validation: {}, placeholder: langText("forgot_username", "label_phone", "Phone number") },
		{ name: "newEmail", validation: { isEmail: true, notEmpty: true }, toLowerCase: true, placeholder: langText("forgot_username", "label_new_email", "New email") },
	];
	FormService.fieldsHoist(fields, fieldsObj);

	const kidRowChangeField = (row, field, value) => {
		row[field] = value;
		kidUpd({ ...row });
	};

	const validateForm = () => {
		const nextErrors = FormService.validateEntireFormHooks(fields, errorsUpd, true);
		const phone = fieldsObj.phone[0].trim();
		const hasChild = kid.name.trim().length > 0 && (kid.birthday || "").trim().length > 0;
		if (!phone && !hasChild) {
			nextErrors.identity = langText("forgot_username", "err_phone_or_child_required", "Enter phone number, or child name and date of birth");
		}
		errorsUpd(nextErrors);
		return !FormService.hasErrors(nextErrors);
	};

	const submitFunc = async () => {
		servErrorUpd(null);
		if (!validateForm()) {
			return;
		}
		submitDisabledUpd(true);

		const sendObj = {
			activetionKey: fieldsObj.activationCode[0].trim(),
			newEmail: fieldsObj.newEmail[0].trim(),
		};
		const phone = fieldsObj.phone[0].trim();
		if (phone.length > 0) {
			sendObj.phoneNU = phone;
		} else {
			sendObj.childName = kid.name.trim();
			sendObj.birthDate = kid.birthday.trim();
			sendObj.gender = kid.gender;
		}

		try {
			const res = await Api.forgotUsername(sendObj);
			if (res.success) {
				ModalService.openToast(langText("errorTexts", "sent_suc", "Request sent"));
				closeForgot();
			} else {
				submitDisabledUpd(false);
				servErrorUpd(langText("errorTexts", "sent_fail", "Request failed"));
			}
		} catch (e) {
			submitDisabledUpd(false);
			servErrorUpd(langText("errorTexts", "sent_fail", "Request failed"));
		}
	};

	const openSecondHand = () => {
		const code = fieldsObj.activationCode[0].trim();
		if (onOpenInitSecondHand) {
			onOpenInitSecondHand(code);
		}
	};

	return (
		<>
			<h5>{langText("forgot_username", "heading", "Forgot your username")}</h5>
			<p>{langText("forgot_username", "hint_verification", "We will send a password only if your activation code and phone or child details match our records.")}</p>
			<ul className="form">
				{fields.map(fieldObj =>
					<li key={fieldObj.name}><InputDiv fieldObj={fieldObj} error={errors[fieldObj.name]} /></li>
				)}
				<li>
					<p>{langText("forgot_username", "section_or_kids", "Or enter child details")}</p>
				</li>
				<KidRow row={kid} onChange={kidRowChangeField} />
				{errors.identity &&
					<li><p className="error">{errors.identity}</p></li>
				}
				<li>
					<p>
						<span className="form-p underline pointer" onClick={openSecondHand}>
							{langText("forgot_username", "link_init_second_hand", "Init account - we got second hand product")}
						</span>
					</p>
				</li>
			</ul>
			<RegiBtns servError={servError}>
				<BaseSubmit onClick={submitFunc} disabled={submitDisabled} label={langText("forgot_username", "button_send_password", "Send password")} />
			</RegiBtns>
		</>
	);
};

export default ForgotUsername;
